import React, { Component } from 'react';
import LayoutSinNavegacion from '../../components/Layout/LayoutSinNavegacion';

class Error extends Component {

    render() {
        return (
            <LayoutSinNavegacion>
                <h1 className="h1 text-gray-900 mt-4">Ocurrió un error</h1>
                {this.props.location.state.errores.map(error => 
                    <p className="lead text-gray-800" key={error}>• {error}</p>
                )}
            </LayoutSinNavegacion>
        )
    }
}

export default Error;